<template>
    <div>
        <input type="hidden"  v-model="requestid"/>
        <Breadcrumbs main="" :title="$t('lbl_EMPBE_SourcingTitle')" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="faq-wrap">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row default-according style-1 faq-accordion" id="accordionoc">
                            <div class="col-12">
                                <b-card no-body v-for="(info,i) in infos" v-bind:key="i">
                                    <b-card-header header-tag="header" role="tab">
                                        <h5 class="mb-0">
                                            <b-button v-b-toggle="'collapseicon'+info.requestId" :id="'requestid_'+info.requestId"  :ref="'requestid_'+info.requestId" 
                                               class="btn btn-link collapsed pl-0">
                                                <table style="width: 100%;">
                                                    <tr>
                                                        <td style="margin-top:unset;text-align:left">
                                                            <span style="font-size: 18px;font-weight: bold;">{{info.formCode}}</span>
                                                            <span v-if="info.Nature==1" class="NatureLabel_1">{{info.natureText}}</span>
                                                            <span v-else-if="info.Nature==2" class="NatureLabel_1">{{info.natureText}}</span>
                                                            <span v-else-if="info.Nature==3" class="NatureLabel_3">{{info.natureText}}</span>
                                                        </td>
                                                        <td class="launchTime">
                                                            <span>发布日期:</span><custom-date  :date="info.createdDate" :args="'yyyy-M-d'"></custom-date>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td  colspan="2"><span style="color:rgba(43, 43, 43, 0.54)">来自{{info.country}}的买家<br/>{{info.productMainTypeName}}-{{info.ProductCatName}} </span></td>
                                                    </tr>
                                                </table>
                                            </b-button>
                                        </h5>
                                    </b-card-header>
                                    <b-collapse :id="'collapseicon'+info.requestId" accordion="accordion-1" role="tabpanel">
                                        <b-card-body>
                                                <table style="width: 100%;">
                                                    <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <label><b>联系方式</b></label><br/>
                                                            <div style="padding-left:50px">
                                                               <table>
                                                                    <tr>
                                                                        <td><span style="width:20%;text-align:right;"><b class="container">公司名称:</b></span></td>
                                                                        <td><span>{{info.contactcompany}}</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><span style="width:20%;text-align:right;"><b class="container">姓名:</b></span></td>
                                                                        <td><span>{{info.contactName}}</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><span style="width:20%;text-align:right;"><b class="container">联系电话:</b></span></td>
                                                                        <td><span>{{info.contactNumber}}</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><span style="width:20%;text-align:right;"><b class="container">联系电邮:</b></span></td>
                                                                        <td><span>{{info.contactEmail}}</span></td>
                                                                    </tr>
                                                               </table>
                                                            </div>
                                                            <hr />
                                                            <div>
                                                                <label><b>采购产品类别</b></label><br/>
                                                                <div style="padding-left:50px">
                                                                    {{info.productMainTypeName}}-{{info.productCatName}}
                                                                </div>
                                                            </div>
                                                            <hr />
                                                            <div>
                                                                <label><b>采购详情</b></label><br/>
                                                                <div style="padding-left:50px">
                                                                    {{info.productDesc}}
                                                                </div>
                                                            </div>
                                                           <div v-if="filesfilter(info.requestId).length>0">
                                                                <hr />
                                                                <div >

                                                                    <label><b>采购相关图片</b></label>
                                                                    <div style="padding-left:50px">
                                                                        <div class="inner-img" v-for="(file,i) in filesfilter(info.requestId)" v-bind:key="i">
                                                                            <img class="img-fluid"
                                                                                :src="file.fileName"
                                                                                :alt="'Product-'+i" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                           </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                        </b-card-body>
                                    </b-collapse>
                                    <div></div>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { SourcingService } from "@/_services/sourcing";
export default {
    data() {
        return {
            requestid:this.$route.query.requestid,
            //重置info
            reloadinfo:false,
            //重置file
            reloadfile:false,
            //设置 - 滚动长度
            settings: {
                maxScrollbarLength: 128
            },
            //查询参数数据
            queryParams:{
                CompId:282389,
                LangId:936
            },
            //采购需求资料
            infos:[],
            //采购需求文件
            files:[]
        };
    },
    //计算层
    computed: {
        //重新过滤图片数据
        filesfilter () {
            return function (requestid) {
                return this.files.filter(function (info, index) {
                    if (info.requestId == requestid) {
                        return info;
                    }
                });
            }
        }
    },
      //监听
    watch:{
 
    },
    created() {
        this.getInfoBycompid();
    },
    methods: {
        async getInfoBycompid(){
            var that=this;
            SourcingService.GetBuyerRequestMatchingByCompidAsync(this.queryParams).then(response => {
                console.log(response);
                if(response.statusCode==200){
                    var data=response.data;
                    that.infos=data.info;
                    that.files=data.files;
                           
                    if(that.requestid!=undefined){
                        //延时触发，展开
                        setTimeout(() => {
                            document.getElementById("requestid_"+that.requestid).click();
                        }, 50);
                    }
                }
            });
        },
    },
    filters:{
	    formatDate: function(value,args) {
			var dt = new Date(value);
			if(args == 'yyyy-M-d') {// yyyy-M-d
			let year = dt.getFullYear();
			let month = dt.getMonth() + 1;
			let date = dt.getDate();
			return `${year}-${month}-${date}`;
		} else if(args == 'yyyy-M-d H:m:s'){// yyyy-M-d H:m:s
			let year = dt.getFullYear();
			let month = dt.getMonth() + 1;
			let date = dt.getDate();
			let hour = dt.getHours();
			let minute = dt.getMinutes();
			let second = dt.getSeconds();
			return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
		} else if(args == 'yyyy-MM-dd') {// yyyy-MM-dd
			let year = dt.getFullYear();
			let month = (dt.getMonth() + 1).toString().padStart(2,'0');
			let date = dt.getDate().toString().padStart(2,'0');
			return `${year}-${month}-${date}`;
		} else if(args == 'HH:mm:ss') {// HH:mm:ss
			let hour = dt.getHours().toString().padStart(2,'0');
			let minute = dt.getMinutes().toString().padStart(2,'0');
			let second = dt.getSeconds().toString().padStart(2,'0');
			return `${hour}:${minute}:${second}`;
		} else {// yyyy-MM-dd HH:mm:ss
			let year = dt.getFullYear();
			let month = (dt.getMonth() + 1).toString().padStart(2,'0');
			let date = dt.getDate().toString().padStart(2,'0');
			let hour = dt.getHours().toString().padStart(2,'0');
			let minute = dt.getMinutes().toString().padStart(2,'0');
			let second = dt.getSeconds().toString().padStart(2,'0');
			return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
		}
	}
},
}
</script>
<style>
    .sourcingTitle {
        color: #E64800 !important;
    }
    .container {
        width: 200px;
        text-align:justify;;
        text-align-last:justify;;
    }
    .inner-img
    {
        width: 120px;
        height: 120px;
        background-color: #fff;
        border-radius: 5px;
        margin-left: 10px;
        margin-right: 10px;
        float: left;
    }
     /*定期/長期需求*/
     .NatureLabel_1 {
        display: inline-block;
        padding: 0 8px;
        background-image: linear-gradient(-45deg, #37b400, #287706);
        border-radius: 2px 0 0 2px;
        color: #fff !important;
        font-family: Roboto-Bold,sans-serif;
        font-size: 12px;
        vertical-align: text-bottom;
    }
    /*一次性需求*/
    .NatureLabel_2 {
        display: none;
        padding: 0 8px;
        background-image: linear-gradient(-45deg, #37b400, #287706);
        border-radius: 2px 0 0 2px;
        color: #fff !important;
        font-family: Roboto-Bold,sans-serif;
        font-size: 12px;
        vertical-align: text-bottom;
    }
    /*緊急需求*/
    .NatureLabel_3 {
        display: inline-block;
        padding: 0 8px;
        background-image: linear-gradient(-45deg, #f5515f, #ff7527);
        border-radius: 2px 0 0 2px;
        color: #fff !important;
        font-family: Roboto-Bold,sans-serif;
        font-size: 12px;
        vertical-align: text-bottom;
    }
    .launchTime{
        text-align:right;
        padding-right: 20px;
    }
</style>
  